import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { validatorPatterns } from '@app/constants';
import { AuthService } from '@app/service/auth.service';
import { LeadDetail } from '@data/lead/lead.interface';
import { leadUtilityFunctions } from '@data/services/lead/lead-utility-functions';
import { LeadService } from '@data/services/lead/lead.service';
import { environment } from '@env/environment';
import { CommonService } from '@shared/services/common/common.service';
import { ToastMsgService } from '@shared/services/toastr/toast-msg.service';
import { QuotesService } from '@data/quotes/quotes.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import moment from 'moment';
import { Subject, Subscription, first, takeUntil } from 'rxjs';

import { SelfServiceEmailService } from '@data/lead/self-service-email.service';

@Component({
  selector: 'app-remote-soa',
  templateUrl: './remote-soa.component.html',
  styleUrls: ['./remote-soa.component.scss']
})
export class RemoteSoaComponent implements OnInit {
  private createEmailDraftSubs:Subscription;
  private getSoAeSignatureSubs:Subscription;
  private _componentDestroyed$ = new Subject<boolean>();
  public remoteForms : FormGroup;
  public minDate : Date;
  public firstLead: LeadDetail | null;
  public maxDate : string;
  public leadDetails : any;
  public userDetails: any;
  public isGenerateDraft : boolean = false;
  public isEmailSOA : boolean = false;
  public generatingDraft : boolean = false;
  public email_types : any = environment;
  public groupByCategory:any;
  public Object = Object;
  public soaType: string = this.data?.soaType || 'remote'; // Default to 'remote' if not provided
  public ldlDisableSoaBulkEmail: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb : FormBuilder,
    private auth: AuthService,
    private _commonService:CommonService,
    private dialog: MatDialog,
    private leadService: LeadService,
    private toastMsgService: ToastMsgService,
    private quotesService: QuotesService,
    private _emailControlService: SelfServiceEmailService,
    public luf : leadUtilityFunctions
  ) {
    this.userDetails = this.auth.user_details;
    this.leadDetails = this.leadService.lead_details;
    this.remoteForms = this.fb.group({
      // Only include 'aptDate' and 'contactMethod' if soaType is 'remote'
      ...(this.soaType === 'remote' && {
      'aptDate': this.leadDetails?.emails?.length > 0 ? ['', Validators.required] : [''],
      'contactMethod': this.leadDetails?.emails?.length > 0 ? ['', Validators.required] : [''],
      }),
      'agentSignature': ['', Validators.required],

      // Add these fields only if leadIDList is not present in this.data
      ...(!this.data?.leadList && {
      'default_email': this.leadDetails?.emails?.length == 0
        ? [this.userDetails.default_email.email, [Validators.required, Validators.pattern(validatorPatterns.EMAIL)]]
        : ['', [Validators.pattern(validatorPatterns.EMAIL)]],
      'leaddefault_email_type': this.leadDetails?.emails?.length == 0 ? ['', Validators.required] : [''],
      'leadEmail': this.leadDetails?.emails?.length == 0
        ? ['', [Validators.required, Validators.pattern(validatorPatterns.EMAIL)]]
        : ['', [Validators.pattern(validatorPatterns.EMAIL)]],
      'selectedEmail': this.leadDetails?.emails?.length > 1 ? ['', [Validators.required]]
        : [''],
      })
    });
    if(!this.data.leadList)
    this.getDisclaimerText();
  else
   this.firstLead = this.data.leadList.length && this.data.leadList[0]
      ? this.data.leadList[0]
      : null;
    this.ldlDisableSoaBulkEmail = this._commonService.ldlDisableSoaBulkEmail;
  }

  ngOnInit(): void {
    this.minDate = new Date();
    this.maxDate = moment(this.minDate).add(1, "year").format("MM/DD/YYYY");
  }

  public checkAptDate(date: string) {
    let futureDate = moment(date).format("MM/DD/YYYY")
    if (moment(futureDate).isAfter(this.maxDate)) {
      this.remoteForms.controls['aptDate'].setErrors({ invalid: true });
    }
  }

  public updateLeadEmail(){

    if(this.remoteForms.invalid){
      return;
    }else{
      this.generatingDraft = true;
      let formData = this.remoteForms.value;
      let payload = {"email_type":formData.leaddefault_email_type,"email": formData.leadEmail,"default_email":"true"}
    this.createEmailDraftSubs = this.leadService.createEmailDraft(payload).subscribe({
        next: (res: any) => {
          this.leadService.getLeadDetails(this.leadService.lead_details.lead_id).pipe(takeUntil(this._componentDestroyed$)).subscribe({
            next: (res: LeadDetail) => {
              this.leadService.lead_details = res;
              this.isGenerateDraft = true;
              this.generatingDraft = false;
            }, error: err => {
              this.generatingDraft = false;
              this.toastMsgService.showError(err.error.message);
            }
          });
        }, error: err => {
          this.generatingDraft = false;
          this.toastMsgService.showError(err.error.message);
        }
      })
    }
  }


 public  getKeys(obj: any):any{
    return obj ? Object.keys(obj) : [];
  }

  private getDisclaimerText(){
    //call API to get cms disclaimer
    var payload={
      user_id:this.auth.getToken().user_id,
      lead_id:this.leadDetails?.lead_id,
      county:this.leadDetails?.default_address.county
    }

    this.leadService.getCarrierPlanGeography(payload,'email').pipe(takeUntil(this._componentDestroyed$)).subscribe({
      next: (response: any) => {
        if (response.success == '0') {
          this.toastMsgService.showError(response.message);
        } else {
          this.groupByCategory = this._commonService.groupByPlanYear(response);
        }
      },
      error: (err) => {
        this.toastMsgService.showError(err.error.message);
      },
      complete: () => {},
    });
  }

  public remoteSOA(){
    const vccPayload = this.data?.vccPayload;
    if(this.remoteForms.invalid){
      return;
    }else{
      this.isEmailSOA = true;
      let formData = this.remoteForms.value;
      this.getSoAeSignatureSubs = this.leadService.getSoAeSignature(formData.agentSignature).subscribe({
        next: (res: any) => {
          let user = this.auth.user_details;
          let agentESignatureID = res.esignature_id;
          let lead = this.leadService.lead_details;
          if(this.soaType === 'Enhanced') {
           //call different endpoint
           let param:any = {
              "self_service_email_requestor_user_id": this.auth.getToken().user_id,
              "lead_id_list": this.data.leadList ? this.data.leadList.map((lead: LeadDetail) => lead.lead_id) : [lead.lead_id],
              "self_service_email_template_type_id": 5,
              "self_service_email_process_type_id": this.data.leadList ? undefined : 5,
              "esignature_id":agentESignatureID,
              "agent_custom_message": ""
            };
            if(this.leadDetails?.emails?.length > 1)
            param.alternate_email_id= this.remoteForms.value.selectedEmail.email_id;
            this._emailControlService.sendEmailInvite(param)
              .pipe(first())
              .subscribe({
                next: () => {
                  this.dialog.closeAll();
                  this.toastMsgService.showSuccess('SOA successfully sent');
                  this.leadService.sendRefreshConvTable('refreshConvTable');
                },
                error: (error: any) => {
                  this.dialog.closeAll();
                  this.toastMsgService.showError(error);
                }
              });
          }else{

          let payload = this.luf.generateRequestPayload(user,agentESignatureID,lead,formData,this.soaType);
          this.leadService.getClientInvite(payload).pipe(first()).subscribe({
            next: (res: any) => {
              if (res.success == 0) {
                if (user.default_phone.phone) {
									this.toastMsgService.showError('The eSignature Scope Of Appointment was not emailed. ' + res.message);
								} else {
									this.toastMsgService.showError('To send eSOA you need to have a phone number in your agent profile. Click on your name in the upper right hand corner and select "Profile" from the drop down to add your agent phone number');
								}
              }else {

                if (vccPayload) {
                  this.quotesService.checkPhysicianLetterPosting(vccPayload);
                }

                this.toastMsgService.showSuccess('The eSignature Scope Of Appointment was emailed.');
                this.leadService.sendRefreshConvTable('refreshConvTable');
							}
              this.dialog.closeAll();
              this.isEmailSOA = false;
            }, error: err => {
              this.isEmailSOA = false;
              this.toastMsgService.showError(err.error.message);
            }
          });
          }

        }, error: err => {
          this.isEmailSOA = false;
          this.toastMsgService.showError(err.error.message);
        }
      })
    }
  }

  public ngOnDestroy(){
    this._componentDestroyed$.next(true);
    this._componentDestroyed$.complete();
    if(this.createEmailDraftSubs) this.createEmailDraftSubs.unsubscribe();
    if(this.getSoAeSignatureSubs) this.getSoAeSignatureSubs.unsubscribe();
  }
}
